import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=df74852e&scoped=true&"
import script from "./Terms.vue?vue&type=script&lang=js&"
export * from "./Terms.vue?vue&type=script&lang=js&"
import style0 from "./Terms.vue?vue&type=style&index=0&id=df74852e&scoped=true&lang=css&"
import style1 from "@/assets/styles/modals.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df74852e",
  null
  
)

export default component.exports